import { render, staticRenderFns } from "./ExportComponent.vue?vue&type=template&id=8208f1da"
import script from "./ExportComponent.vue?vue&type=script&lang=js"
export * from "./ExportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports